import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { QuickChatService } from 'app/layout/common/quick-chat/quick-chat.service';
import { catchError, forkJoin, of } from 'rxjs';

export const initialDataResolver = () => {
    const navigationService = inject(NavigationService);
    const notificationsService = inject(NotificationsService);
    const quickChatService = inject(QuickChatService);

    // Fork join multiple API endpoint calls to wait all of them to finish.
    // Each call is isolated with catchError so a single failing endpoint
    // (these are secondary UI data, not the page's own content) can't block
    // the whole navigation — without this, forkJoin never emits on any one
    // failure, the resolver never completes, and the route never activates,
    // leaving the app stuck on the splash screen with no redirect.
    return forkJoin([
        navigationService.get().pipe(catchError(() => of(null))),
        notificationsService.getAll().pipe(catchError(() => of(null))),
        quickChatService.getChats().pipe(catchError(() => of(null))),
    ]);
};
